import { render, staticRenderFns } from "./deptManageTest.vue?vue&type=template&id=1ae1c2c0"
import script from "./deptManageTest.vue?vue&type=script&lang=js"
export * from "./deptManageTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae1c2c0')) {
      api.createRecord('1ae1c2c0', component.options)
    } else {
      api.reload('1ae1c2c0', component.options)
    }
    module.hot.accept("./deptManageTest.vue?vue&type=template&id=1ae1c2c0", function () {
      api.rerender('1ae1c2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/dim/deptManageTest.vue"
export default component.exports